var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 18c0 9.941-8.059 18-18 18-9.94 0-18-8.059-18-18S8.06 0 18 0c9.941 0 18 8.059 18 18z",
    fill: "#F89521"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.63 21.687a.719.719 0 0 0 .72.719h3.982a.245.245 0 0 1 .158.064l3.005 3.006a.525.525 0 0 0 .899-.374v-2.445a.224.224 0 0 1 .23-.223h1.186a.719.719 0 0 0 .719-.718v-6.183a.72.72 0 0 0-.719-.719h-3.99",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19.865 10.5H8.4a.898.898 0 0 0-.899.9v7.454a.913.913 0 0 0 .906.906h1.438a.273.273 0 0 1 .273.273v2.998a.64.64 0 0 0 1.093.453l3.637-3.638a.288.288 0 0 1 .194-.086h4.824a.897.897 0 0 0 .935-.899V11.4a.9.9 0 0 0-.927-.898h-.008z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.8d1fba56641194ca517336408a29e05d.svg";
export { ForwardRef as ReactComponent };